export default __webpack_public_path__ + "images/TH.27b6cba.png";